var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowWinHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1919,
    height: 167,
    viewBox: "0 0 1919 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M646 118.371C618.4 152.76 595.5 160.358 580.5 164.856C567.5 167.856 545 169.355 528.5 157.859C512 146.362 462.5 124.5 423 118.371C383.5 112.241 104.5 91.5 0.5 102.376V0H1923V37.8955C1916.33 38.8952 811 42.5 760 53.5C709 64.5 680.5 75.384 646 118.371Z",
    fill: "#FFD12C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWinHeader);
export default __webpack_public_path__ + "static/media/YellowWinHeader.7c7ac87f1b2f47eb21b9.svg";
export { ForwardRef as ReactComponent };